import { HttpStatusCode } from 'axios';
import apiFetcher from '../interCeptor';

export const GetTimingsApi = async ({ params, body, byEmoployee = false }) => {
    try {
        let url;
        if (params?.booking_id) {
            url = `api/v1/store/booking/timings?service_id=${params.service_id}&date=${params.date}&employee_id=${params.employee_id}&custom_duration=${params.custom_duration}&whole_day=true&ignore_booking_id=${params.booking_id}`;
        } else if (byEmoployee) {
            url = `api/v1/store/booking/multi-timings-by-employee?date=${params?.date}&ignore_booking_id=${params?.ignore_booking_id}&whole_day=true&consider_employee_hours=false`;
        } else {
            url = `api/v1/store/booking/timings?service_id=${params.service_id}&date=${params.date}&employee_id=${params.employee_id}&custom_duration=${params.custom_duration}&whole_day=true`;
        }
        const response = await apiFetcher.post(url, body);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const CreateBookingApi = async ({ isEdit, body }) => {
    try {
        const response = await apiFetcher.post(`api/v1/store/booking/${isEdit ? 'edit-multi' : 'multi'}`, body);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const DeleteBookingApi = async ({ body, soft_delete = true }) => {
    try {
        const response = await apiFetcher.post(`api/v1/store/booking/delete?soft_delete=${soft_delete}`, body);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const GetFormNotificationApi = async () => {
    try {
        const response = await apiFetcher.get(`api/v1/store/form-notifications`);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const ReadFormNotificationApi = async ({ id }) => {
    try {
        const response = await apiFetcher.post(`api/v1/store/form-notifications/${id}/read`);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const SendFormEmailApi = async ({ id }) => {
    try {
        const response = await apiFetcher.post(`api/v1/store/booking/send-customer-info-email/${id}`);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const SendFormSmsApi = async ({ id }) => {
    try {
        const response = await apiFetcher.post(`api/v1/store/booking/send-customer-info-sms/${id}`);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const getInspectionExtraCostApi = async ({
    zip_code,
    latitude,
    longitude,
    service_group_ids,
    customer_id,
    service_ids,
    booking_id,
}) => {
    const payloadParams = {
        customer_zip_code: zip_code,
        customer_latitude: latitude,
        customer_longitude: longitude,
    };

    if (service_group_ids !== undefined && service_group_ids !== null && service_group_ids !== '') {
        payloadParams.service_group_ids = Array.isArray(service_group_ids)
            ? service_group_ids.join(',')
            : service_group_ids;
    }

    if (customer_id !== undefined && customer_id !== null && customer_id !== '') {
        payloadParams.customer_id = customer_id;
    }

    if (service_ids !== undefined && service_ids !== null && service_ids !== '') {
        payloadParams.service_ids = Array.isArray(service_ids) ? service_ids.join(',') : service_ids;
    }

    if (booking_id !== undefined && booking_id !== null && booking_id !== '') {
        payloadParams.booking_id = booking_id;
    }

    try {
        const response = await apiFetcher.get(
            `api/v1/store/booking/get_inspection_extra_cost?${new URLSearchParams(payloadParams).toString()}`,
        );
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};

export const MarkAsFreeApi = async ({ groupBookingUuid }) => {
    try {
        const response = await apiFetcher.post(`api/v1/store/booking/mark-as-free/${groupBookingUuid}`);
        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created) {
            return response;
        }
    } catch (error) {
        throw new Error(error);
    }
};
